<template>
  <div class="grid-content">
    <div class="loading" v-loading="loading">
      <el-form ref="globalPriceSetting" :model="model" :rules="rules" label-width="120px" label-position="left">
        <el-row>
          <el-col>
            <el-checkbox v-model="getAll" @change="onGetAllChange">查看所有</el-checkbox>
          </el-col>
        </el-row>
        <el-row v-for="item in universityList" :key="item.Key">
          <div>
            <div>
              <span class="input-width">{{ item.Value }}</span>
              <el-button v-if="!optionModel.isReadonly" size="medium" type="text" icon="el-icon-plus"
                @click="addAdvanceEnrollment(item.Key)">添加占位规则</el-button>
            </div>
          </div>
          <el-row :gutter="16" v-for="ae in advanceEnrollmentList" :key="ae.Key" v-if="ae.UniversityId == item.Key">
            <el-col :span="6">
              <el-form-item label="提前占位单价" prop="advanceEnrollmentPrice.Value">
                <el-input :disabled="!ae.Enable || optionModel.isReadonly" placeholder="请输入价格" v-model="ae.Amount"
                  class="input-width">
                  <template slot="append">
                    $
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="提前占位折扣" prop="">
                <el-input :disabled="!ae.Enable || optionModel.isReadonly" placeholder="请输入折扣" v-model="ae.Discount"
                  class="input-width">
                  <template slot="append">
                    %
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="备注" label-width="80px" prop="">
                <el-input :disabled="!ae.Enable || optionModel.isReadonly" placeholder="请输入备注" v-model="ae.Comment"
                  maxlength="250" class="input-width ca-adPrice-comment">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="合同" prop="" label-width="80px">
                <el-select :disabled="!ae.Enable || optionModel.isReadonly" placeholder="请选择合同" v-model="ae.ContractId"
                  class="input-width ca-adPrice-contract" clearable>
                  <el-option v-for="item in contractList" :key="item.Value" :label="item.Text" :value="item.Value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2" v-if="!optionModel.isReadonly">
              <el-button size="small" v-if="ae.Enable" @click="ae.Enable = !ae.Enable" type="danger" class="enableButton">
                停用</el-button>
              <el-button size="small" v-if="!ae.Enable" @click="ae.Enable = !ae.Enable" type="primary"
                class="enableButton">启用</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <hr>
            </el-col>
          </el-row>
        </el-row>
        <!--<el-row>
          <el-col :span="8">
            <el-form-item label="提前占位单价"
                          prop="advanceEnrollmentPrice.Value">
              <el-input :disabled="optionModel.isReadonly"
                        placeholder="请输入价格"
                        v-model="model.advanceEnrollmentPrice.Value"
                        class="input-width">
                <template slot="append">
                  $
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>-->
        <el-row>
          <el-col :span="8">
            <el-form-item label="职业培训占位单价" prop="trainingAdvanceEnrollmentPrice.Value">
              <el-input :disabled="optionModel.isReadonly" placeholder="请输入价格"
                v-model="model.trainingAdvanceEnrollmentPrice.Value" class="input-width">
                <template slot="append">
                  $
                </template>
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="18">
            <hr>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row v-if="!optionModel.isReadonly" class="cs-filter-row">
      <el-col :span="4" class="footer-left">
        <el-button size="medium" :disabled="submitBtnDisable" :type="submitBtnClass" @click="saveChanges">保存更新
        </el-button>
      </el-col>
      <el-col :span="16" class="footer-right">
        <el-alert :closable="false" v-show="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    overflow: visible;
    white-space: nowrap;
    padding-right: 10px;
  }

  .el-input {
    text-align-last: center;
    min-width: 120px;
    width: 50%;

    &.ca-adPrice-comment,
    &.ca-adPrice-contract {
      width: 70%;
    }
  }

  .enableButton {
    margin-left: 20px;
    margin-top: 5px;
  }

  .el-form-item {
    margin-left: 10px;
  }

}
</style>

<script>
import {
  getGlobalPriceSettings,
  saveGlobalPriceSettings
} from "../../service/globalPriceSetting.service";

import { 
  saveUniversityAdvanceEnrollments, 
  getUniversityAdvanceEnrollments 
} from "../../service/advanceEnrollment.service";

import { getGlobalPriceSettingByType } from "../../config/mUtils";
import {
  getUniversities
} from "../../service/common.service";
import { getContractList } from "@/service/contract.service";

export default {
  props: {
    isActive: Boolean,
    options: {
      isReadonly: Boolean
    }
  },
  data() {
    //Get University
    getUniversities(true).then(result => {
      if (!!result && result.success) {
        this.universityList = this.universityList.concat(result.data);
      }
    });

    //Get Contract
    getContractList(this.GLOBAL.contractType.advanceEnrollment, true).then(result => {
      if (!!result && result.success) {
        this.contractList = this.contractList.concat(result.data);
      }
    });

    let validateValue = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入正确的价格";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }

    };

    let validateDiscountValue = (rule, value, callback) => {
      let message = "";
      let pattern = /^-?\d+$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "折扣只允许输入整数";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }

    };

    return {
      getAll: false,
      isLoadedData: false,
      loading: false,
      optionModel: {
        isReadonly: false
      },
      submitBtnClass: "primary",
      submitBtnDisable: false,
      showError: false,
      errorMessage: "",
      model: {
        advanceEnrollmentPrice: {},
        trainingAdvanceEnrollmentPrice: {}
      },
      rules: {
        advanceEnrollmentPrice: {
          Value: [
            {
              required: true,
              message: "提前占位价格不能为空",
              trigger: "blur"
            },
            {
              validator: validateValue,
              trigger: "blur"
            }
          ],
          Discount: [
            {
              required: true,
              message: "提前占位折扣不能为空",
              trigger: "blur"
            },
            {
              validator: validateDiscountValue,
              trigger: "blur"
            }
          ]
        },
        trainingAdvanceEnrollmentPrice: {
          Value: [
            {
              required: true,
              message: "职业培训提前占位价格不能为空",
              trigger: "blur"
            },
            {
              validator: validateValue,
              trigger: "blur"
            }
          ]
        }
      },
      universityList: [],
      advanceEnrollmentList: [],
      contractList: [],
    };
  },
  components: {},
  computed: {},
  created() {
    this.loadOptionModelFromProps();
    this.loadGlobalPriceSetting();
    this.loadAdvanceEnrollments();
  },
  updated() {
    //this.checkAllInputs();
  },
  methods: {
    loadOptionModelFromProps(options = this.options) {
      if (!!options) {
        this.optionModel.isReadonly = options.isReadonly;
      } else {
        this.optionModel.isReadonly = false;
      }
    },
    checkAllInputs() {
      let isValid = true;

      let $refGPS = this.$refs["globalPriceSetting"];
      if (!!$refGPS) {
        $refGPS.validate(valid => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      if (isValid) {
        //this.submitBtnClass = "primary";
        //this.submitBtnDisable = false;
      } else {
        //this.submitBtnClass = "info";
        //this.submitBtnDisable = true;
      }

      return isValid;
    },
    loadGlobalPriceSetting() {
      if (!this.isActive) {
        return;
      }
      this.loading = true;
      let gpTypes = [
        this.GLOBAL.globalPriceType.advanceEnrollmentPrice,
        this.GLOBAL.globalPriceType.trainingAdvanceEnrollmentPrice
      ];
      getGlobalPriceSettings(gpTypes).then(result => {
        if (!!result && result.success) {
          let advanceEnrollmentPrice = getGlobalPriceSettingByType(
            result.data,
            this.GLOBAL.globalPriceType.advanceEnrollmentPrice
          );
          let trainingAdvanceEnrollmentPrice = getGlobalPriceSettingByType(
            result.data,
            this.GLOBAL.globalPriceType.trainingAdvanceEnrollmentPrice
          );
          if (!advanceEnrollmentPrice) {
            advanceEnrollmentPrice = this.initGlobalPriceSetting(
              this.GLOBAL.globalPriceType.advanceEnrollmentPrice
            );
          }
          if (!trainingAdvanceEnrollmentPrice) {
            trainingAdvanceEnrollmentPrice = this.initGlobalPriceSetting(
              this.GLOBAL.globalPriceType.trainingAdvanceEnrollmentPrice
            );
          }
          this.model.advanceEnrollmentPrice = advanceEnrollmentPrice;
          this.model.trainingAdvanceEnrollmentPrice = trainingAdvanceEnrollmentPrice;
          this.loading = false;
          this.isLoadedData = true;
        }
      });
    },
    saveChanges() {
      let self = this;

      let isValid = this.checkAllInputs();
      if (!isValid) {
        return;
      }
      var result = this.saveAdvanceEnrollment();

      //let cacheSubmitBtnDisable = this.submitBtnDisable;
      //this.submitBtnDisable = true;
      let gtSettings = [
        this.model.advanceEnrollmentPrice,
        this.model.trainingAdvanceEnrollmentPrice
      ];
      saveGlobalPriceSettings(gtSettings).then(result => {
        if (!result) {
          return;
        }

        if (result.success) {
          this.loadGlobalPriceSetting();
          self.errorMessage = "";
        } else {
          self.errorMessage = result.message;
        }
        self.showError = !result.success;
        this.$message(`保存更新${!self.showError ? "成功" : "失败"}`);
        //self.submitBtnDisable = cacheSubmitBtnDisable;
      });
    },
    initGlobalPriceSetting(type) {
      let gpSetting = {
        Id: 0,
        Enable: true,
        Type: type,
        Value: 0
      };

      return gpSetting;
    },
    addAdvanceEnrollment(uid) {
      let newAdvanceEnrollment = {
        Id: 0,
        UniversityId: uid,
        Amount: 200,
        Discount: 70,
        Comment: "",
        ContractId: null,
        Enable: true
      };
      this.advanceEnrollmentList.push(newAdvanceEnrollment);
    },
    loadAdvanceEnrollments() {
      this.loading = true;
      getUniversityAdvanceEnrollments(this.getAll).then(result => {
        if (!!result && result.success) {
          this.advanceEnrollmentList = result.data;
        }
        this.loading = false;
      });
    }, 
    saveAdvanceEnrollment() {
      saveUniversityAdvanceEnrollments(this.advanceEnrollmentList).then(result => {
        if (result && result.success) {
          this.loadAdvanceEnrollments();
          return true;
        } else {
          return false;
        }
      });

    },
    onGetAllChange(){
      this.loadAdvanceEnrollments();
    }
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
        this.loadGlobalPriceSetting();
      }
    },
    options: function (newVal) {
      this.loadOptionModelFromProps(newVal);
    }
  }

};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/advanceEnrollmentPrice.vue